module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[61]182.3be3414.woff2";